export default __webpack_public_path__ + "static/media/openSeaLogo.65aa6244.svg";